import { AlertBox } from '@iwoca/orion';

import { useImpersonatedStateKey } from '../../hooks/useStateKey';
import { useGetProfile } from '../../lendingApi/lendingApiQueries';

const StaffErrorBanner = () => {
  const { profile } = useGetProfile();
  const impersonatedStateKey = useImpersonatedStateKey();

  if (!profile || profile.user_type !== 'staff' || impersonatedStateKey)
    return null;

  return (
    <AlertBox variant="failure">
      New applications cannot be created as a staff member, to create a new
      customer please logout or continue in an incognito browser. If you are
      trying to view an existing customer please impersonate with a statekey.
    </AlertBox>
  );
};

export default StaffErrorBanner;
